import AccountForm from '@/components/shared/AccountForm'
import AuthenticatedLayout from '@/layouts/AuthenticatedLayout'
import { useOrgPath } from '@/lib/pathFor'

interface Props {
  user: { name: string | null; email_address: string }
}

export default function AccountShow({ user }: Props) {
  const pathFor = useOrgPath()
  return <AccountForm user={user} patchUrl={pathFor('/account')} />
}

AccountShow.layout = (page: React.ReactNode) => (
  <AuthenticatedLayout>{page}</AuthenticatedLayout>
)
